export enum RegistrationTypeEnum {
  COMPANY_ADMIN = 'Company Admin',
  SUPER_ADMIN = 'Super Admin',
}
